import React, { useState } from 'react'
import Element from './Element'
import { RxCross2 } from 'react-icons/rx'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { base_url } from '../../utilities'
import Loader from '../Reusable_Components/loader'
import { MdOutlineFileDownload } from "react-icons/md";
import { convertUTCToLocal } from '../Reusable_Components/ReusableFunctions'

export default function ViewForm({ closeForm, form_items, prefilledData, submitFormData, formData, tableData, handleFormData, viewOnly, footerDetails, orientation }) {

    const normalizedItems = Array.isArray(form_items) ? form_items : (form_items?.items || [])
    const itemsOrientation = Array.isArray(form_items) ? null : form_items?.orientation
    const [form, setForm] = useState(normalizedItems)
    const [loader, setLoader] = useState(false)

    const resolvedOrientation = (orientation || itemsOrientation) === "landscape" ? "landscape" : "portrait"
    const isLandscape = resolvedOrientation === "landscape"
    const pageW = isLandscape ? "297mm" : "210mm"
    const pageH = isLandscape ? "210mm" : "297mm"
    const formViewMaxWidth = pageW

    const downloadPdf = () => {
        setLoader(true)
        let audit_details = { ...footerDetails }

        if (audit_details.created_at) {
            audit_details.created_at = convertUTCToLocal(audit_details.created_at);
        }
        if (audit_details.filled_at) {
            audit_details.filled_at = convertUTCToLocal(audit_details.filled_at);
        }
        if (audit_details.reviewed_at) {
            audit_details.reviewed_at = convertUTCToLocal(audit_details.reviewed_at);
        }
        let body = {
            form: normalizedItems,
            form_data: formData ? formData : {},
            form_name: "testing",
            audit_history: audit_details,
            orientation: resolvedOrientation
        }
        axios.post(base_url + 'pdfgenerator/generateformpdf', body)
            .then((res) => {
                const linkSource = `data:application/pdf;base64,${res.data.data.pdf}`;
                const downloadLink = document.createElement("a");
                const fileName = "form.pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setLoader(false)
            })
            .catch((err) => {
                console.log(err)
                setLoader(false)
            })
    }

    const getPrefilledData = (obj=formData) => {
          const filteredObject = obj && Object.fromEntries(
            Object.entries(obj).filter(([key, value]) => !key.includes("-"))
          );
        return filteredObject;
    }

    return (
        <div className='form_preview_container' style={{ overflow: 'auto', alignItems: 'flex-start', padding: '20px 0' }}>
            <style>{`@page { size: A4 ${resolvedOrientation}; margin: 5mm; }`}</style>
            <div className='form_view a4-paper' style={{
                width: pageW,
                maxWidth: pageW,
                minHeight: pageH,
                height: 'auto',
                padding: '5mm',
                boxSizing: 'border-box',
                backgroundColor: 'white',
                boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
            }}>
                <div style={{ position: "absolute", top: "10px", right: "60px",border :"1px solid gray",padding:"2px",borderRadius:"6px",cursor:"pointer"}} onClick={downloadPdf}>
                    <MdOutlineFileDownload title='download' />
                    <span style={{ marginLeft: "5px", fontSize: "12px" }}>Download</span>
                </div>
                <RxCross2 className='close-form' onClick={() => {
                    closeForm()
                }} />
                <div className='mt-3'>
                    {form?.map((previewObj, rowIndex) => {
                        return <div key={previewObj.id} id={previewObj.id + " " + rowIndex} className='d-flex' style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                            {previewObj.items.map((item, index) => {
                                return <Element rowIndex={rowIndex} colIndex={index} prefilledData={prefilledData ? prefilledData : getPrefilledData()} object={item} key={index} handleFormData={handleFormData} tableData={tableData} formUse={true} preview={true} data={formData} viewOnly={viewOnly} />
                            })}
                        </div>
                    })}
                </div>
                <div className='mt-3'>
                    {footerDetails && <>
                        <hr></hr>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                            <thead>
                                <tr>
                                    <th>Created by</th>
                                    <th>Filled by</th>
                                    <th>Reviewed by</th>
                                </tr>
                            </thead>
                            <tbody style={{ fontSize: "10px" }}>
                                <tr>
                                    <td style={{ padding: "5px" }}>{footerDetails?.created_by}<br />{convertUTCToLocal(footerDetails?.created_at)}</td>
                                    <td style={{ padding: "5px" }}>{footerDetails?.filled_by}<br />{footerDetails?.filled_at && convertUTCToLocal(footerDetails?.filled_at)}</td>
                                    <td style={{ padding: "5px" }}>{footerDetails?.reviewed_by}<br />{footerDetails?.reviewed_at && convertUTCToLocal(footerDetails?.reviewed_at)}</td>
                                </tr>
                            </tbody>
                        </table>
                        <hr></hr>
                    </>
                    }
                </div>

                <div className='d-flex justify-content-end gap-2'>
                    <button className='btn btn-primary secondary-button' onClick={() => {
                        // setPreview(false)
                        closeForm()
                    }}>Close</button>
                    {submitFormData && <button className='btn btn-primary' onClick={() => {
                        submitFormData()
                    }}>Submit</button>}
                </div>
            </div>

            {loader && <Loader />}
        </div>
    )
}
